export const Qualification = [
    { name: 'SR. CARDIOLOGIST', code: 'SR. CARDIOLOGIST' },
    { name: 'CARDIOLOGIST', code: 'CARDIOLOGIST' },
    { name: '1ST YR RESIDENT', code: '1ST YR RESIDENT' },
    { name: '2ND YR RESIDENT', code: '2ND YR RESIDENT' },
    { name: '3RD YR RESIDENT', code: '3RD YR RESIDENT' },
    { name: 'SURGEON', code: 'SURGEON' },
    { name: 'MBBS', code: 'MBBS' },
    { name: 'CAT-LAB TECH', code: 'CAT-LAB TECH' },
    { name: 'MD', code: 'MD' },
]